import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./warningModal.html";
class WarningModal extends LightningElement {
  constructor(...args) {
    super(...args);
    this.descriptionText = void 0;
    this.cancelLabel = void 0;
    this.submitLabel = void 0;
  }
  handleDialogClose(event) {
    event.preventDefault();
    this.dispatchEvent(new CustomEvent('closedialog', {
      bubbles: true
    }));
  }
  handleSubmitAction(event) {
    event.preventDefault();
    this.dispatchEvent(new CustomEvent('saveandsubmit'));
  }
  get fillIconColor() {
    return getComputedStyle(this.template.host).getPropertyValue('--c360-g-color-palette-blue-50');
  }
  get fillWarningIconColor() {
    return getComputedStyle(this.template.host).getPropertyValue('--c360-g-color-warning-base-4');
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(WarningModal, {
  publicProps: {
    descriptionText: {
      config: 0
    },
    cancelLabel: {
      config: 0
    },
    submitLabel: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(WarningModal, {
  tmpl: _tmpl,
  sel: "pricing-warning-modal",
  apiVersion: 62
});
export default __lwc_component_class_internal;